import { motion } from 'framer-motion';

interface WideImageProps {
  src: string;
  alt: string;
  caption?: string;
  size?: 'full' | 'half';
}

export function WideImage({ src, alt, caption, size = 'full' }: WideImageProps) {
  const isHalf = size === 'half';
  return (
    <motion.figure
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`space-y-4 ${isHalf ? 'mx-auto w-full max-w-[640px]' : ''}`}
    >
      <div className="relative overflow-hidden rounded-[2rem] bg-black/[0.03] p-2 md:p-3">
        <img
          src={src}
          alt={alt}
          className="block h-auto w-full rounded-[1.4rem] object-contain"
          loading="lazy"
        />
      </div>
      {caption ? (
        <figcaption
          className={`label ${
            isHalf ? 'text-center' : ''
          }`}
        >
          {caption}
        </figcaption>
      ) : null}
    </motion.figure>
  );
}
